<template>
	<div id="app">
		<Transfer/>
	</div>
</template>

<script>
	import Transfer from './components/Transfer.vue'

	export default {
		name: 'app',
		components: {
			Transfer
		},
	}
</script>

<style>
	#app {
		padding: 0px;
		margin: 0px;
		position: absolute;
		top: 0px;
		left: 0px;
		width: 100%;
		height: calc(100% - 4px);
		border: hidden;
	}
</style>
